function openNav() {
  document.getElementById("mySidenav").style.width = "250px";
}

function closeNav() {
  document.getElementById("mySidenav").style.width = "0";
}

window.addEventListener('click', function (e) {
  if (document.getElementById('mySidenav').contains(e.target)) {
    // Clicked in box
  } else {
    // Clicked outside the box
    if (document.getElementById("mySidenav").offsetWidth) {
      document.getElementById("mySidenav").style.width = "0";
    }
  }
})